export default "__VITE_ASSET__C1_5bJIm__"